import React from "react";

//Import Breadcrumb
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Radio, RadioGroup } from "@mui/material";

const RadioButtonGroupInGrid = ({ title, error, data, setValue, required, name, value, disabled, sm, xs }) => {
    return (
        <React.Fragment>
            <FormControl variant="standard" fullWidth>
                <FormLabel style={{ fontFamily: 'Manrope-SemiBold', fontSize: 14 }}>
                    {title}
                    {required && error && <FormHelperText sx={{ color: "red" }}> Please select an option</FormHelperText>}
                </FormLabel>
                <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue=""
                    value={(value === "" || value === null || value === undefined) ? "-1" : value}
                    name={name}
                    style={{ fontFamily: 'Manrope-SemiBold' }}
                    onChange={(e) => disabled ? "" : setValue(e.target.value)}

                >
                    <Grid container>
                        {
                            data && data.length > 0 && data.map((x, idx) =>
                                <Grid item xs={xs || 12} sm={sm || 6} key={idx}>
                                    <FormControlLabel value={x.value} key={idx} style={{ fontFamily: 'Manrope-SemiBold', fontSize: 14, marginBottom: 0 }}
                                        control={<Radio sx={{
                                            '&.Mui-checked': {
                                                color: "#44d62c",
                                            },
                                        }} />}
                                        label={
                                            <>
                                                <div style={{ fontFamily: 'Manrope', fontSize: 14 }}>{x.label}</div>
                                                {
                                                    x?.description && <div style={{ fontSize: 13, color: '#74788D', marginTop: '5px', fontWeight: '300' }}>{x.description}</div>
                                                }
                                            </>
                                        }
                                    />
                                </Grid>
                            )
                        }
                    </Grid>
                </RadioGroup>
                {/* {required && error && <FormHelperText> Please select an option</FormHelperText>} */}
            </FormControl>
        </React.Fragment >
    );
};

export default RadioButtonGroupInGrid;
